var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.72667 5.99967C6.8834 5.55412 7.19277 5.17841 7.59997 4.9391C8.00717 4.69978 8.48593 4.6123 8.95145 4.69215C9.41697 4.772 9.83921 5.01402 10.1434 5.37536C10.4476 5.7367 10.614 6.19402 10.6133 6.66634C10.6133 7.99967 8.61333 8.66634 8.61333 8.66634M8.66667 11.333H8.67333M15.3333 7.99967C15.3333 11.6816 12.3486 14.6663 8.66667 14.6663C4.98477 14.6663 2 11.6816 2 7.99967C2 4.31778 4.98477 1.33301 8.66667 1.33301C12.3486 1.33301 15.3333 4.31778 15.3333 7.99967Z",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "2d1c529effce9c4d9d7a9442c60f2b51.svg";
export { ForwardRef as ReactComponent };